// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Item_attributes_OpcoesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/item_attributes/opcoes/{attribute_id}
 *
 * Returns the active options for the given item attribute. Legacy
 * `dados` shape is a list, so getDados() returns the array directly.
 */
import type { Item_attributes_OpcaoRow } from './Item_attributes_OpcaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Item_attributes_OpcoesResponseDados = Item_attributes_OpcaoRow[];

export type Item_attributes_OpcoesResponse = ApiResponse<Item_attributes_OpcoesResponseDados>;

registerResponseContract('Item_attributes_OpcoesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_item_attribute_option_id:            { type: 'number',  required: true },
      so_item_attribute_option_attribute_id:  { type: 'number',  required: true },
      so_item_attribute_option_value:         { type: 'string',  required: true },
      so_item_attribute_option_icon_svg:      { type: 'string',  required: false },
      so_item_attribute_option_display_order: { type: 'number',  required: true },
      so_item_attribute_option_active:        { type: 'number',  required: true },
      so_item_attribute_option_created_at:    { type: 'string',  required: true },
    },
  },
})
